import React from 'react';
import { alpha, Stack, SxProps, Theme, Typography } from '@mui/material';
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';

import palette from '@/theme/palette.ts';

type ImageUploadAreaProps = {
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  truncatedForm: boolean;
  sx?: SxProps<Theme>;
};

export const ImageUploadArea = ({
  getRootProps,
  getInputProps,
  truncatedForm,
  sx,
}: ImageUploadAreaProps) => {
  return (
    <Stack
      {...getRootProps()}
      direction="column"
      justifyContent="center"
      alignItems="center"
      px={2}
      py={4}
      sx={{
        border: '2px dashed',
        borderColor: truncatedForm ? palette.primary.main : '#F49404',
        borderRadius: 2,
        cursor: 'pointer',
        minWidth: '210px',
        minHeight: '180px',
        '&:hover': { borderColor: '#F49404' },
        backgroundColor: truncatedForm ? alpha(palette.primary.main, 0.05) : alpha('#F49404', 0.05),
        transition: 'all 0.5s ease-in-out',
        ...sx,
      }}
    >
      <input {...getInputProps()} />
      <span
        className="material-symbols-rounded"
        style={{
          marginBottom: '1rem',
          fontSize: truncatedForm ? '4rem' : '2.5rem',
          color: truncatedForm ? palette.primary.main : '#F49404',
          borderRadius: '50px',
          transition: 'all 0.5s ease-in-out',
          border: truncatedForm ? `1px dashed ${palette.primary.main}` : 'none',
        }}
      >
        add
      </span>
      {!truncatedForm && (
        <>
          <Typography
            variant="overline"
            sx={{ color: '#F49404', textDecoration: 'underline', textTransform: 'none' }}
          >
            {'Klikněte pro nahrání obrázku'}
          </Typography>
          <Typography variant="caption" py={1} color={'#000'}>
            {'nebo přetáhněte sem'}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            PNG, JPG (max. 3MB)
          </Typography>
        </>
      )}
    </Stack>
  );
};
